<template>
    <v-container fluid>
        <v-row v-if="!!error.show">
            <v-col cols="12">
                <v-alert color="error" dark>{{ error.message }}</v-alert>
            </v-col>
        </v-row>
        <v-row v-if="!error.show">
            <v-col cols="12">
                <h3>Вебинар {{ webinarInfo.course_title }}</h3>
            </v-col>
            <v-col cols="12">
                Вебинар начнется в
            </v-col>
        </v-row>
        <v-row v-if="!error.show">
            <v-col cols="12">
                <code>{{ webinarInfo }}</code>
            </v-col>
            <v-col cols="12">
                <code>{{ user }}</code>
            </v-col>
        </v-row>
        <v-dialog v-model="loader.show" hide-overlay persistent width="300">
            <v-card color="orange darken-3" dark>
                <v-card-text>
                    {{ loader.message }}
                    <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
                </v-card-text>
            </v-card>
        </v-dialog>
    </v-container>
</template>
<script>
  import moment from 'moment'
  import tz from 'moment-timezone'

  const b64DecodeUnicode = (str) => {
    return decodeURIComponent(atob(str).split('').map(function (c) {
      return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
    }).join(''))
  }

  const timeout = async (ms) => {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  export default {
    data: () => ({
      error: {
        show: false,
        message: null
      },
      loader: {
        show: false,
        message: 'Подождите...'
      },
      webinarInfo: {
        course_title: null,
        id: null,
      },
      user: {
        id: null,
      }
    }),
    filters: {},
    methods: {
      loaderWidget: function (method = 'hide', text = 'Подождите...') {
        this.loader.message = text
        if(method === 'show') {
          this.loader.show = true
        } else {
          this.loader.show = false
        }
      },
      decodeData: function () {
        this.webinarInfo.id = b64DecodeUnicode(this.$route.params.eventid)
        this.user.id = b64DecodeUnicode(this.$route.params.userid)
      },
      getUserInfo: async function () {
        if(!!this.error.show) return false
        this.loaderWidget('show', 'Загрузка данных о пользователе...')
        try {
          const r = await this.$http.get(`${this.$store.getters.api}v4/my/userinfo?user=${this.webinarInfo.id}`)
        } catch (e) {
          this.error.message = 'Ошибка загрузки данных о пользователе. Повторите попытку или проверьте правильность адреса страницы.'
          this.error.show = true
          console.log('getUserInfo err', e)
        }
        this.loaderWidget('hide')
      },
      getWebinarInfo: async function () {
        if(!!this.error.show) return false
        this.loaderWidget('show', 'Загрузка данных о вебинаре...')
        try {
          const r = await this.$http.get(`${this.$store.getters.api}v4/my/webinarinfo?webinar=${this.webinarInfo.id}`)
          console.log('webinar', r.data)
          if(r.data.error) {
            this.error.message = r.data.error
            this.error.show = true
          } else {

          }
        } catch (e) {
          this.error.message = 'Ошибка загрузки данных о вебинаре. Повторите попытку или проверьте правильность адреса страницы.'
          this.error.show = true
          console.log('getWebinarInfo err', e)
        }
        this.loaderWidget('hide')
      },
      generateZoomLink: async function () {
        if(!!this.error.show) return false
        this.loaderWidget('show', 'Регистрация на вебинаре...')
        try {

        } catch (e) {
          console.log('getWebinarInfo err', e)
        }
        this.loaderWidget('hide')
      },
      redirectToZoom: async function () {
        if(!!this.error.show) return false
        this.loaderWidget('show', 'Переадресация на вебинар')
        await timeout(2000)
        this.loaderWidget('hide')
      }
    },
    async mounted () {
      this.decodeData()
      await this.getUserInfo()
      await this.getWebinarInfo()
    },
  }
</script>
<style>

</style>